module.exports = __webpack_public_path__ + "img/hiringProcess-icon.a0500dab.svg";